import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";

export interface HtmlBlock extends NoteBlock {
  html: string;
  type: "omega/query-omega/page/block/html/HtmlPageBlock";
}

export interface NoteEdits {
  [index: number]: string;
}

export function isNoteBlock(block: NoteBlock): block is HtmlBlock {
  return (block as HtmlBlock).html !== undefined;
}

export const newHtmlBlock: (config: {
  html: string;
  pageId: string;
  appId: string;
}) => HtmlBlock = ({ html, pageId, appId }) => {
  return {
    type: "omega/query-omega/page/block/html/HtmlPageBlock",
    html,
    "block-id": uuidv4(),
    "page-id": pageId,
    "app-id": appId,
  };
};
